import script from "./SignUpAccountTypePage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpAccountTypePage.vue?vue&type=script&setup=true&lang=js"

import "./SignUpAccountTypePage.vue?vue&type=style&index=0&id=198b47b2&lang=scss"

const __exports__ = script;

export default __exports__